import { render, staticRenderFns } from "./ConfigurazioneReparto.vue?vue&type=template&id=4d2fe444&scoped=true&"
import script from "./ConfigurazioneReparto.vue?vue&type=script&lang=js&"
export * from "./ConfigurazioneReparto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2fe444",
  null
  
)

export default component.exports